export const IFRAME_SENDER = "ams_sdk";
export const UNAUTHORIZED_IFRAME_POSTBACK = {
  topic: "ams_sdk_send_back",
  type: "error",
  payload: {
    message: "Unauthorized",
    status: 401,
  },
};
